import React from 'react'

import DataTable from '@/components/datatable/DataTable'
import ServiceFeesTableHeaders from '@/components/misc/ServiceFeesTable/ServiceFeesTableHeaders'
import ServiceFeesTableRows, {
  ServiceFeesTableRowsProps,
} from '@/components/misc/ServiceFeesTable/ServiceFeesTableRows'
import { TableBody, TableHeader } from '@/components/ui/table'
import { buildDebugTooltip } from '@/lib/helpers/helperFunctions'
import serviceFeeService from '@/lib/services/serviceFeeService'
import { CommercialAgreementTypeOption } from '@/redux/slices/commercialAgreementsForm'
import {
  ReferralConsentLetterVariant,
  ReferralConsentStage,
} from '@/types/misc'

type Props = Omit<ServiceFeesTableRowsProps, 'showExampleColumn'> & {
  agreementType: CommercialAgreementTypeOption
  className?: string
  consentLetterVariant: ReferralConsentLetterVariant
  referralConsentStage: ReferralConsentStage
}

const ServiceFeesTable: React.FC<Props> = ({
  className,
  consentLetterVariant,
  referralConsentStage,
  serviceFees,
  agreementType,
  ...props
}) => {
  const showExampleColumn = serviceFeeService.shouldShowExampleColumn({
    serviceFees,
    agreementType,
    referralConsentStage,
    consentLetterVariant,
  })

  return (
    <DataTable
      tableContainerProps={{
        className,
        title: buildDebugTooltip({
          commercialAgreementId: props.commercialAgreementId,
        }),
      }}
      tableProps={{ alignTop: true, bordered: true }}
    >
      <TableHeader>
        <ServiceFeesTableHeaders
          serviceFees={serviceFees}
          isRecommendedPartnerTerms={props.isRecommendedPartnerTerms}
          agreementType={agreementType}
          isPreviewLetter={props.isPreviewLetter}
          showExampleColumn={showExampleColumn}
        />
      </TableHeader>

      <TableBody>
        <ServiceFeesTableRows
          referralConsentStage={referralConsentStage}
          consentLetterVariant={consentLetterVariant}
          showExampleColumn={showExampleColumn}
          serviceFees={serviceFees}
          {...props}
        />
      </TableBody>
    </DataTable>
  )
}

export default ServiceFeesTable
